import { render, staticRenderFns } from "./ComerciosView.vue?vue&type=template&id=e701acb2&"
import script from "./ComerciosView.vue?vue&type=script&lang=ts&"
export * from "./ComerciosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports